"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProviders = void 0;
const ethers_1 = require("ethers");
// Let's not over engineer this. We won't have that many networks - Classicus
function createProviders(keys) {
    return {
        1: new ethers_1.providers.AlchemyProvider(1, keys.alchemyAPI.homestead),
        4: new ethers_1.providers.AlchemyProvider(4, keys.alchemyAPI.rinkeby),
        137: new ethers_1.providers.AlchemyProvider(137, keys.alchemyAPI.polygon),
        80001: new ethers_1.providers.AlchemyProvider(80001, keys.alchemyAPI.mumbai),
    };
}
exports.createProviders = createProviders;
//# sourceMappingURL=index.js.map